// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sigin-container {
    background: #111111;
    height: 100vh;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
}

.logo {
    width: 160px;
    height: 160px;
}

.form {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 350px;
    margin-top: 30px;
    gap: 16px;
}

label {
    font-size: 14px;
    font-weight: bold;
    color: white;
    margin-bottom: 4px;
}

.input-wrapper {
    display: flex;
    flex-direction: column;
    width: 350px;
    height: 75px;
    gap: 16px;
}

input {
    background-color: #000;
    border: 1px solid #888;
    border-radius: 6px;
    padding: 12px;
    color: white;
    font-size: 14px;
    outline: none;
    font-family: Arial, Helvetica, sans-serif;
}

.signin-button{
    margin-top: 60px;
    background: #1CD66A;
    font-weight: bold;
    font-size: 14px;
    width: 300px;
    border: none;
    padding: 14px;
    border-radius: 24px;
    cursor: pointer;
    transition: background 0.3s;
}

.signin-button:hover {
    background-color: #1db954;
}

.message {
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/styles/signin.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".sigin-container {\n    background: #111111;\n    height: 100vh;\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n}\n\n.logo {\n    width: 160px;\n    height: 160px;\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    max-width: 350px;\n    margin-top: 30px;\n    gap: 16px;\n}\n\nlabel {\n    font-size: 14px;\n    font-weight: bold;\n    color: white;\n    margin-bottom: 4px;\n}\n\n.input-wrapper {\n    display: flex;\n    flex-direction: column;\n    width: 350px;\n    height: 75px;\n    gap: 16px;\n}\n\ninput {\n    background-color: #000;\n    border: 1px solid #888;\n    border-radius: 6px;\n    padding: 12px;\n    color: white;\n    font-size: 14px;\n    outline: none;\n    font-family: Arial, Helvetica, sans-serif;\n}\n\n.signin-button{\n    margin-top: 60px;\n    background: #1CD66A;\n    font-weight: bold;\n    font-size: 14px;\n    width: 300px;\n    border: none;\n    padding: 14px;\n    border-radius: 24px;\n    cursor: pointer;\n    transition: background 0.3s;\n}\n\n.signin-button:hover {\n    background-color: #1db954;\n}\n\n.message {\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
